module.exports = __webpack_public_path__ + "img/logo2.29faa006.png";